export var Page;

(function (Page) {
  Page["LANDING"] = "LANDING";
  Page["GET_API_KEY"] = "GET_API_KEY";
  Page["API_KEY_DETAIL"] = "API_KEY_DETAIL";
  Page["HELP"] = "HELP";
  Page["NFTS_MINTED"] = "NFTS_MINTED";
  Page["NFTS_LAZY"] = "NFTS_LAZY";
  Page["PREFERENCES"] = "PREFERENCES";
})(Page || (Page = {}));